import { useEffect, useState } from 'react'
import { fetchShareSendableBySchedule } from '../api/scheduleShareApi'

/**
 * 스케줄 번호별 알림톡 발송 가능 여부(서버 shareSendable). 조회 전·실패면 null — 호출 화면은 null 을
 * '모름'으로 보고 막지 않는다(발송 API 가 서버에서 다시 판정해 422 로 거부한다).
 * enabled=false 면 조회하지 않는다. refreshKey 가 바뀌면 다시 조회한다.
 */
export function useShareSendableMap(enabled: boolean, refreshKey: number | string = 0): Map<number, boolean> | null {
  const [map, setMap] = useState<Map<number, boolean> | null>(null)

  useEffect(() => {
    if (!enabled) return
    const controller = new AbortController()
    fetchShareSendableBySchedule(controller.signal)
      .then(setMap)
      .catch((err: { name?: string }) => {
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') return
        setMap(null)
      })
    return () => controller.abort()
  }, [enabled, refreshKey])

  return map
}
